// @flow

import { beginRequest, completeRequest } from "@store/utils";
import * as actions from "@modules/reporting/constants/actions";
import { cloneObject } from "@utils/object";
import type { HealthReportState } from "./types";
import initialState from "./state";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: HealthReportState) => () => startRequest(state);
export const setLoaded = (state: HealthReportState) => () => finishRequest(state);

export const onGetDataForecastsSuccess = (state: HealthReportState) => ({ payload }: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    workForceReport: payload,
  };
};

export const onGetCarePlansReportSuccess = (state: HealthReportState) => ({ payload }: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    carePlansReport: payload,
  };
};

export const onGetWellbeingAdviceReportSuccess = (state: HealthReportState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    wellbeingAdviceReport: payload,
  };
};

export const onGetNurseAssessmentsReportSuccess = (state: HealthReportState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    nurseAssessmentsReport: payload,
  };
};

export default (state: HealthReportState = initialState, action: Object): HealthReportState => {
  const act = {
    [actions.GetWorkForceHealth]: setLoading,
    [actions.GetWorkForceHealthSuccess]: onGetDataForecastsSuccess,
    [actions.GetWorkForceHealthError]: setLoaded,
    [actions.ExportWorkForceReport]: setLoading,
    [actions.ExportWorkForceReportSuccess]: setLoaded,
    [actions.ExportWorkForceReportError]: setLoaded,

    [actions.GetCarePlansReport]: setLoading,
    [actions.GetCarePlansReportSuccess]: onGetCarePlansReportSuccess,
    [actions.GetCarePlansReportError]: setLoaded,
    [actions.ExportCarePlansReport]: setLoading,
    [actions.ExportCarePlansReportSuccess]: setLoaded,
    [actions.ExportCarePlansReportError]: setLoaded,

    [actions.GetWellbeingAdviceReport]: setLoading,
    [actions.GetWellbeingAdviceReportSuccess]: onGetWellbeingAdviceReportSuccess,
    [actions.GetWellbeingAdviceReportError]: setLoaded,
    [actions.ExportWellbeingAdviceReport]: setLoading,
    [actions.ExportWellbeingAdviceReportSuccess]: setLoaded,
    [actions.ExportWellbeingAdviceReportError]: setLoaded,

    [actions.GetNurseAssessmentsReport]: setLoading,
    [actions.GetNurseAssessmentsReportSuccess]: onGetNurseAssessmentsReportSuccess,
    [actions.GetNurseAssessmentsReportError]: setLoaded,
    [actions.ExportNurseAssessmentsReport]: setLoading,
    [actions.ExportNurseAssessmentsReportSuccess]: setLoaded,
    [actions.ExportNurseAssessmentsReportError]: setLoaded,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
